import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

/*
import { MatPaginatorIntl } from '@angular/material/paginator';
export class MatPaginatorIntlTw extends MatPaginatorIntl {
  override itemsPerPageLabel = '每頁筆數';
  override nextPageLabel = '下一頁';
  override previousPageLabel = '上一頁';

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 / ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} / ${length}`;
  }
}
*/
// @Injectable({
//   providedIn: 'root',
// })
export class JkPaginatorService {
  //subList: any[] =[];
  //allItems: any[] = [];
  paginatorObj!: MatPaginator;
  dataSource! : MatTableDataSource<any>;//any[] = [];

  startIndex: number = 0;
  endIndex: number = 0;
  setObj(paginatorObj: MatPaginator,itemList:any[]) { // , allItems: any[],subList: any[]
    this.paginatorObj = paginatorObj;
    this.dataSource = new MatTableDataSource<any>(itemList)      ;
    this.dataSource.paginator = this.paginatorObj;
  //this.allItems = allItems;
    //this.subList = subList;
    this.init();
    //this.paginatorObj.pageSize = this.paging.pageSize;
    //this.paginatorObj.length = this.pageLength;
  }
  //pageLength = 0;
  get length(): number {
    if(this.paginatorObj)
      return this.paginatorObj.length
    else
      return 0;
  }
  set length(value: number) {
    if(this.paginatorObj)
      this.paginatorObj.length = value;
  }
  //pageSize = 5;
  get pageSize(): number {
    if(!this.paginatorObj){
      //console.error('get pageSize:paginatorObj is null');
      return 0;
    }
    else
    return this.paginatorObj.pageSize;
  }
  set pageSize(value: number) {
    if(!this.paginatorObj){
      //console.error('set pageSize:paginatorObj is null');
    }
    else
    this.paginatorObj.pageSize = value;
    this.paginatorObj.pageIndex = 0;
  }
  get pageIndex(): number {
    if(!this.paginatorObj){
      console.error('get pageIndex:paginatorObj is null');
      return 0;
    }
    else
      return this.paginatorObj.pageIndex;
  }
  set pageIndex(value: number) {
    if(!this.paginatorObj){
      console.error('set pageIndex:paginatorObj is null');
    }
    else
      this.paginatorObj.pageIndex = value;
  }
  set pageSizeOptions(value: number[]) {
    if(this.paginatorObj)
      this.paginatorObj.pageSizeOptions = value;
  }
  get pageSizeOptions(): number[] {
    return this.paginatorObj.pageSizeOptions;
  }
  get showFirstLastButtons(): boolean {
    return this.paginatorObj.showFirstLastButtons;
  }
  set showFirstLastButtons(value: boolean) {
    this.paginatorObj.showFirstLastButtons = value;
  }

  //pageSizeOptions = [5, 10, 25];
  i: number = 0;
  //hidePageSize = false;
  get hidePageSize(): boolean {
    return this.paginatorObj.hidePageSize;
  }
  set hidePageSize(value: boolean) {
    this.paginatorObj.hidePageSize = value;
  }
  //showPageSizeOptions = true;
  get showPageSizeOptions(): boolean {
    return this.paginatorObj.pageSizeOptions.length === 0 ? false : true;
  }
  set showPageSizeOptions(value: boolean) {
    if (!value) this.paginatorObj.pageSizeOptions = [];
  }

  //disabled = false;
  get disabled(): boolean {
    return this.paginatorObj.disabled;
  }
  set disabled(value: boolean) {
    this.paginatorObj.disabled = value;
  }
  pageEvent: PageEvent = new PageEvent();
  callback?: (e: PageEvent) => void;
  constructor() {
  }
  init() {
    this.pageSizeOptions = [5, 10, 25, 50];
    this.pageSize = 10;
    this.showFirstLastButtons = true;
    this.paginatorObj._intl.firstPageLabel ='第一頁';
    this.paginatorObj._intl.itemsPerPageLabel = '每頁筆數';
    this.paginatorObj._intl.nextPageLabel = '下一頁';
    this.paginatorObj._intl.previousPageLabel = '上一頁';
    this.paginatorObj._intl.lastPageLabel = '最後一頁';
    this.paginatorObj._intl.getRangeLabel = this.getRangeLabel;
    /*this.paginatorObj._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 / ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} / ${length}`;
    }*/
        //this.paginatorObj.PageEvent = this.handlePageEvent;
  }
  getRangeLabel(page: number, pageSize: number, length: number):string{
    if (length === 0 || pageSize === 0) {
      return `0 / ${length}`;
    }
    length = Math.max(length, 0);
    //const startIndex = page * pageSize;
    //const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    this.startIndex = page * pageSize;
    this.endIndex = this.startIndex < length ? Math.min(this.startIndex + pageSize, length) : this.startIndex + pageSize;
    return `${this.startIndex + 1} - ${this.endIndex} / ${length}`;
  }
  /*
  refreshList(subList:any[],allItems:any[]) {
    subList = [];
    for (
      let i = this.pageIndex * this.pageSize;
      i < (this.pageIndex + 1) * this.pageSize;
      i++
    ) {
      if (i < this.allItems.length) {
        this.subList.push(this.allItems[i]);
      }
    }
    let j = this.subList.length;
  }*/
  handlePageEvent(e: PageEvent) {
    if (this.paginatorObj) {
      this.pageEvent = e;
      this.length = e.length;
      this.pageSize = e.pageSize;
      this.pageIndex = e.pageIndex;
      if (this.callback) this.callback(e);
    }
    // this.refreshList(); 改在外部處理
  }
  getPager( allItems: any[]):any[] {
    let pagedItems: any[] = [];

      if(!this.paginatorObj)
        return [];
      if(this.paginatorObj && allItems)
        this.length = allItems.length;
      if (this.length >= 0) {
        let pages = this.paginatorObj.getNumberOfPages();

        if (this.paginatorObj.pageIndex > pages) {
          this.paginatorObj.pageIndex = 0;
        }
        this.startIndex =
          (this.paginatorObj.pageIndex ) * this.paginatorObj.pageSize;
        this.endIndex = Math.min(
          this.startIndex + this.paginatorObj.pageSize - 1,
          this.length - 1
        );
        pagedItems = allItems.slice(
          this.startIndex,
          this.endIndex + 1
        );
      } else {
        pagedItems = [];
        this.startIndex = -1;
        this.endIndex = -1;
      }
    //});
    return pagedItems;
  }

}
